<template>
    <b-container v-if="$can('view-credits') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Credit Memos</h3>
                    </b-col>
                    <b-col class="buttons-create text-right">
                        <b-button variant="outline-primary" size="sm" :to="{ name: 'CreditsCreate' }">New Credit Memo
                        </b-button>
                        <b-button v-if="$can('execute-export') || $can('view-all')" variant="outline-primary" size="sm" @click="openModal('export-columns')">Export
                        </b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('adjust-columns')"><i
                                class="fas fa-columns"></i></b-button>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>

        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="3">
                        <b-form-group>
                            <b-input-group size="sm">
                                <b-form-input v-model="tables.credits.filter" type="search" id="filterInput"
                                    placeholder="Type to Search" debounce="500"></b-form-input>
                                <b-input-group-append>
                                    <b-button :disabled="!tables.credits.filter" @click="tables.credits.filter = ''">
                                        Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <!-- <b-col class="text-center" cols="3">
                        <b-button v-if="tables.credits.hasQueryClicks" variant="danger" size="sm" @click="clearQueryClicks">Clear Filters</b-button>
                    </b-col> -->

                    <b-col cols="8" />

                    <b-col cols="1">
                        <b-form-group>
                            <b-form-select v-model="tables.credits.perPage" id="perPageSelect" size="sm"
                                :options="tables.credits.pageOptions"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-credits-table">
                    <b-container fluid>
                        <b-table v-if="tables.credits.ready" ref="creditsTable" :key="tables.credits.key" class="credits-table"
                            responsive bordered striped hover no-border-collapse sticky-header="calc(100vh - 250px)"
                            head-variant="light" :items="creditsProvider"
                            :fields="visibleFields" :sort-by.sync="tables.credits.sortBy"
                            :sort-desc.sync="tables.credits.sortDesc"
                            :per-page="tables.credits.perPage" :current-page.sync="tables.credits.currentPage"
                            :filter="tables.credits.filter" :busy.sync="tables.credits.isBusy">

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(id)="row">
                                <b-link :ref="'creditsTableRow' + row.item.id" @click="saveState('creditsTableRow' + row.item.id)"
                                    :to="{name: 'CreditsDetail', params: { creditNum: row.item.id } }">{{
                                    row.item.id }}</b-link>
                            </template>

                            <template v-slot:cell(customer)="row">
                                <b-link @click="saveState('creditsTableRow' + row.item.id)" :to="{name: 'CustomerDetail', params: {id: row.item.customer.id}}">{{ row.item.customer.name }}</b-link>
                            </template>

                            <template v-slot:cell(credits_applieds)="row">
                                <div v-if="row.item.credits_applieds">
                                    <div v-for="applied in row.item.credits_applieds" :key="applied.id">
                                        <!-- {{ applied.sales_order.sales_order_number }} - ${{ applied.applied_amount }}<br /> -->
                                        <b-link @click="saveState('creditsTableRow' + row.item.id)"
                                            :to="{ name: 'SalesOrderDetail', params: { soNum: applied.sales_order.sales_order_number } }">{{ applied.sales_order.sales_order_number }}
                                        </b-link> - ${{ applied.applied_amount }}<br />

                                    </div>
                                </div>
                            </template>

                            <!-- <template v-slot:cell(amount_total)="row">
                                <span>$ {{ numberWithCommas(row.item.amount_total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(amount_available)="row">
                                <span>$ {{ numberWithCommas(row.item.amount_available) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(deposit_acct)="row">
                                <span>{{ row.item.deposit_acct ? row.item.deposit_acct.name : '' }}</span>
                            </template>

                            <template v-slot:cell(payment_method)="row">
                                <span>{{ row.item.payment_method ? row.item.payment_method.name : '' }}</span>
                            </template> -->

                            <template v-slot:cell(status)="row">
                                <span>{{ formatStatus(row.item.status) }}</span>
                            </template>

                            <template v-slot:cell(created_by)="row">
                                <span>{{ row.item.created_by_user ? row.item.created_by_user.name : '' }}</span>
                            </template>

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <!-- <b-col>
                                            <b-link @click="openModal('edit-customer', row.item)"><i class="fas fa-edit"></i></b-link>
                                        </b-col>
                                        <b-col v-if="$can('view-all')">
                                            <b-link @click="" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col> -->
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination v-model="tables.credits.currentPage" :total-rows="tables.credits.totalRows"
                            :per-page="tables.credits.perPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <modal-adjust-columns v-if="modals['adjust-columns'].active" :fields="modals['adjust-columns'].fields"
            @saveColSaves="saveColSaves" />

        <modal-export-columns v-if="modals['export-columns'].active" :fields="modals['export-columns'].fields"
            :ignores="modals['export-columns'].ignores" @exportExcel="exportExcel" />
    </b-container>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import ModalAdjustColumns from '../common/modals/AdjustColumns'
import ModalExportColumns from '../common/modals/ExportColumns'
import { mapMutations } from 'vuex'
import tableColumnPreferences from '../../../mixins/tableColumnPreferences'
export default {
    name: 'Credits',

    mixins: [tableColumnPreferences],

    metaInfo() {
        return {
            title: 'Credits',
        }
    },

    components: {
        Treeselect,
        'modal-adjust-columns': ModalAdjustColumns,
        'modal-export-columns': ModalExportColumns
    },
    data() {
        return {
            modals: {
                'adjust-columns': {
                    active: 0,
                    fields: []
                },

                'export-columns': {
                    active: 0,
                    fields: [],
                    ignores: ['actions']
                },
            },
            tables: {
                credits: {
                    filteredItems: [],
                    isBusy: false,
                    totalRows: 0,
                    currentPage: 1,
                    perPage: 20,
                    pageOptions: [20, 50, 100, 500],
                    sortBy: 'date',
                    sortDesc: true,
                    // sortDirection: 'asc',
                    filter: null,
                    filterCat: '',
                    key: 1,
                    userFields: [],
                    fields: [
                        {
                            key: 'id',
                            label: 'Credit Memo #',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'date',
                            label: 'Date',
                            thClass: 'credits-table-style-th-datetime',
                            tdClass: 'credits-table-style-td-datetime',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'customer',
                            label: 'Customer',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'reference',
                            label: 'Reference',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'notes',
                            label: 'Notes',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'amount_total',
                            label: 'Amount Total',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'amount_available',
                            label: 'Amount Available',
                            sortable: true,
                            visible: 1
                        },
                        // {
                        //     key: 'deposit_acct',
                        //     label: 'Deposit Account',
                        //     sortable: true,
                        //     visible: 1
                        // },
                        // {
                        //     key: 'payment_method',
                        //     label: 'Payment Method',
                        //     sortable: true,
                        //     visible: 1
                        // },
                        {
                            key: 'status',
                            label: 'Status',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'credits_applieds',
                            label: 'Applied To',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'created_by',
                            label: 'Created By',
                            sortable: false,
                            visible: 1
                        },
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'credits-table-style-actions',
                            visible: 1
                        }
                    ],

                    items: [],
                    ready: 0
                },
            },

            exports: {
                cols: []
            }
        }
    },
    methods: {
        formatStatus(status) {
            if (!status) return '';
            return status === 'Closed' ? 'Ready' : status;
        },

        exportExcel(cols, keys) {
            let url = 'api/orders/creditmemos/exportcredits'
            axios.post(url, {
                search: this.tables.credits.filter,
                sortBy: this.tables.credits.sortBy,
                sortDesc: this.tables.credits.sortDesc,
                cols: cols,
                keys: keys
            },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
        },

        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'credits_Export_File_' + +new Date() + '.xlsx') //or any other extension
            document.body.appendChild(link)
            link.click()

            this.showAlertBox('success', 'File Generated', 'Sales Orders export file generated successfully!')
        },

        saveState(name) {
            let page = this.tables.credits.currentPage
            let filter = this.tables.credits.filter
            let perPage = this.tables.credits.perPage
            this.setRememberCredit({ name: name, page: page, filter: filter, perPage: perPage })
        },

        openModal(modalName, row, extra) {
            let prefix = 'modal-lists-credits-'
            switch (modalName) {
                case 'adjust-columns':
                    this.modals[modalName].active = 1

                    this.modals[modalName].fields = this.cloneFieldsForAdjust(this.tables.credits.userFields, this.tables.credits.fields)

                    break
                case 'export-columns':
                    this.modals[modalName].active = 1

                    this.modals[modalName].fields = JSON.parse(JSON.stringify(this.tables.credits.fields.filter(e => !this.modals[modalName].ignores.includes(e.key))))

                    break
            }

            if (modalName == 'adjust-columns' || modalName == 'export-columns') {
                prefix = 'modal-common-'
            }

            this.$nextTick(() => {
                this.$bvModal.show(prefix + modalName)
            })
        },

        toggleBusy() {
            this.tables.credits.isBusy = !this.tables.credits.isBusy
        },

        creditsProvider(ctx) {
            return this.scheduleProviderFetch('credits', ctx, (latestCtx) => {
                const normalized = this.normalizeTableProviderContext(latestCtx, this.tables.credits)
                let payload = {
                    page: normalized.currentPage,
                    perPage: normalized.perPage,
                    sortBy: normalized.sortBy,
                    sortDesc: normalized.sortDesc,
                    search: normalized.filter
                }

                return axios.post('api/orders/creditmemos/getcredits', payload)
                    .then((res) => {
                        this.tables.credits.items = res.data.credits
                        this.tables.credits.totalRows = res.data.total
                        return res.data.credits || []
                    }, () => {
                        this.has_error = true
                        return []
                    })
            })
        },

        initCredits() {
            this.tables.credits.filter = this.rememberedPayment.filter || ''
            this.tables.credits.perPage = this.rememberedPayment.perPage || 20

            if (this.rememberedCredit.page) {
                this.tables.credits.currentPage = this.rememberedCredit.page
            }

            this.tables.credits.ready = 1

            this.$nextTick(() => {
                this.setLastState()
            })
        },

        setLastState() {
            this.$nextTick(() => {
                if (this.rememberedCredit.name && this.rememberedCredit.page) {
                    this.tables.credits.currentPage = this.rememberedCredit.page
                    this.$nextTick(() => {
                        this.$refs[this.rememberedCredit.name].$el.scrollIntoView()
                    })
                }
            })
        },

        // ...mapMutations({
        //     setRemember: 'remembered/SET_PAYMENT'

        // }),

        getColSaves() {
            let url = 'api/remembertable/getcolsaves/credits'
            axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            const merged = this.mergeColSaves(this.tables.credits.fields, res.data.colSaves.column_array)
                            if (merged) {
                                this.tables.credits.userFields = merged
                            }
                        }

                        this.initCredits()
                    }
                }, () => {
                    this.has_error = true
                })
        },

        saveColSaves(fields) {
            const normalized = this.normalizeColumnOrder(fields)
            this.tables.credits.userFields = normalized
            let url = 'api/remembertable/savecolsaves'
            axios.post(url, {
                area: 'credits',
                fields: this.formatColSavesPayload(normalized)
            })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
        },

        forceRerender() {
            this.tables.credits.ready = 0
            let tempFields = this.tables.credits.fields
            this.tables.credits.fields = []
            this.$nextTick(() => {
                this.tables.credits.fields = tempFields
                this.tables.credits.ready = 1
            })
        }
    },

    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.tables.credits.fields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key }
                })
        },

        pageTotals() {
            let totalRows = this.tables.credits.totalRows
            let currentPage = this.tables.credits.currentPage
            let perPage = this.tables.credits.perPage

            if (!totalRows) {
                return 'Showing 0 of 0 rows'
            }

            let from = ((currentPage - 1) * perPage) + 1
            let to = Math.min(currentPage * perPage, totalRows)

            return 'Showing ' + from + ' to ' + to + ' of ' + totalRows + ' rows'
        },

        visibleFields() {
            return this.buildVisibleFields(this.tables.credits.fields, this.tables.credits.userFields)
        }
    },

    mounted() {
        this.getColSaves()

        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            switch (modalId) {
                case 'modal-common-adjust-columns':
                    this.modals['adjust-columns'].active = 0
                    this.modals['adjust-columns'].fields = []

                    break
                case 'modal-common-export-columns':
                    this.modals['export-columns'].active = 0
                    this.modals['export-columns'].fields = []

                    break
            }
        })

        // pusher
        // Echo.channel('table-payment-updated')
        //     .listen('TablePaymentUpdated', (e) => {
        //         this.getcredits(1)
        // })
    }
}
</script>
<style lang="scss">
.vue-treeselect__control {
    // height: calc(1.5em + 0.5rem + 2px);
    // padding-top: 0.25rem;
    // padding-bottom: 0.25rem;
    // padding-left: 0.5rem;
    font-size: 0.875rem !important;

    .vue-treeselect__placeholder,
    .vue-treeselect__single-value {
        // line-height: 1.5
    }
}

.credits-table {
    height: 75vh;
    font-size: 9pt;

    .credits-table-style-actions {
        min-width: 120px;

        .actions-icons {
            text-align: center;
            white-space: nowrap;
        }
    }

    .credits-table-style-th-datetime {
        min-width: 110px;
    }

    .credits-table-style-td-datetime {
        text-align: center;
    }
}
</style>
